import {
    DashboardTaskItemFields,
    DashboardTasksFormFields,
} from '../interfaces';

export enum DASHBOARD_TIME_RANGES {
    WEEK = 'WEEK',
    MONTH = 'MONTH',
    QUARTER = 'QUARTER',
    YEAR = 'YEAR',
}

export const dashboardTaskTableDefaultValues = {
    [DashboardTasksFormFields.newTasks]: [],
};

export const dashboardTaskItemDefaultValues = {
    [DashboardTaskItemFields.id]: '',
    [DashboardTaskItemFields.completed]: false,
    [DashboardTaskItemFields.priority]: 'none',
    [DashboardTaskItemFields.dueDate]: '',
    [DashboardTaskItemFields.description]: '',
    [DashboardTaskItemFields.duration]: '',
};

export const SOURCES_SORT_FIELDS = {
    ENTRIES: 'entries',
    APPLY: 'apply',
} as const;

export type SourcesSortField =
    (typeof SOURCES_SORT_FIELDS)[keyof typeof SOURCES_SORT_FIELDS];
